import React, { useState, useEffect, useRef } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { IoIosSend } from "react-icons/io";
import { Post, Get } from "../../config/api"; // Assume you have these functions for API calls
import swal from "sweetalert";
import { CHAT, MESSAGE, UPLOADS_URL } from "../../config/constants/api";
import socket from "../../config/socket/index";
import { useSelector } from "react-redux";

const ChatComponent = ({ isChatVisible, data, setIsChatVisible }) => {
  const [chatId, setChatId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);
  const msgerChatRef = useRef(null);
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (isChatVisible) {
      if (messages.length === 0) {
        setLoading(true);
      }
      // Ensure chat exists and fetch messages
      const initializeChat = async () => {
        try {
          Post(
            CHAT.createChat,
            {
              chauffeur: data?.chauffeur?._id,
              user: userData?._id,
            },
            token
          )
            .then((response) => {
              if (response?.status) {
                setChatId(response?.data?._id);
                Get(`${MESSAGE.getChatMessages}${response?.data?._id}`, token)
                  .then((response) => {
                    if (response?.status) {
                      setMessages(response.data.docs); // Update messages in state
                      setLoading(false);
                    }
                  })
                  .catch((err) => {
                    setLoading(false);
                    console.log("Error fetching messages", err);
                  });
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        } catch (error) {
          console.error("Error initializing chat:", error);
        }
      };

      initializeChat();
    }
  }, [isChatVisible]);

  useEffect(() => {
    socket.on("message", (newMessage) => {
      if (newMessage.chat === chatId) {
        setMessages((prevMessages) => [...prevMessages, newMessage]);
      }
    });

    return () => {
      socket.off("message");
    };
  }, [chatId, socket]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        chatContainerRef.current &&
        !chatContainerRef.current.contains(event.target)
      ) {
        setIsChatVisible(false); // Close chat if clicking outside
      }
    };

    if (isChatVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isChatVisible, setIsChatVisible]);
  useEffect(() => {
    if (msgerChatRef.current) {
      msgerChatRef.current.scrollTop = msgerChatRef.current.scrollHeight;
    }
  }, [messages]);

  const sendMessage = async (e) => {
    e.preventDefault();
    if (newMessage.trim() === "") return;
    Post(
      MESSAGE.createMessage,
      { chatId, content: newMessage, senderType: "user" },
      token
    )
      .then((response) => {
        if (response?.status) {
          const createdMessage = response.data;
          socket.emit("new message", {
            ...createdMessage,
            reciever: data.chauffeur._id,
            sender: userData?._id,
          });
          setMessages([...messages, createdMessage]); // Update local message state
          setNewMessage("");
        }
      })
      .catch((err) => {
        const message = err?.response?.data?.message || err?.message;
        if (message) {
          swal("Error", message, "error");
        }
        console.log(err, "error");
      });
    setNewMessage("");
  };

  return (
    <section className="msger" ref={chatContainerRef}>
      <main className="msger-chat" ref={msgerChatRef}>
        {messages.map((msg, index) => {
          const isLastInSequence =
            index === messages.length - 1 ||
            messages[index + 1].senderType !== msg.senderType;

          return (
            <div
              className={`msg ${
                msg.senderType === "user" ? "right-msg" : "left-msg"
              }`}
              key={index}
            >
              {isLastInSequence ? (
                <img
                  alt="Profile"
                  src={
                    msg.senderType === "user"
                      ? `${UPLOADS_URL}${userData?.image}`
                      : `${UPLOADS_URL}${data?.chauffeur?.image}`
                  }
                  style={{
                    maxHeight: "60px",
                    maxWidth: "60px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              ) : (
                <div
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                  }}
                ></div>
              )}

              <div className="msg-bubble">
                <div className="msg-info">
                  <div className="msg-info-name">
                    {msg.senderType === "user"
                      ? "You"
                      : data?.chauffeur.firstName}
                  </div>
                  <div className="msg-info-time">
                    {new Date(msg.createdAt).toLocaleTimeString()}
                  </div>
                </div>
                <div className="msg-text">{msg.content}</div>
              </div>
            </div>
          );
        })}
        {loading && (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        )}
      </main>

      <form className="msger-inputarea" onSubmit={sendMessage}>
        <input
          type="text"
          className="msger-input"
          placeholder="Enter your message..."
          onChange={(e) => setNewMessage(e.target.value)}
          value={newMessage}
        />
        <button
          type="submit"
          className="msger-send-btn"
          disabled={newMessage === ""}
        >
          <IoIosSend />
        </button>
      </form>
    </section>
  );
};

export default ChatComponent;
